var hamburger = document.querySelector(".hamburger");
var subNav = document.querySelector(".sub-navigation");
hamburger.addEventListener("click", function() {
	if(hamburger.classList.contains('is-active')) {
		hamburger.classList.toggle("is-active");		
		subNav.classList.remove("slide-in-blurred-bottom");
		subNav.classList.toggle("slide-out-blurred-bottom");
		  setTimeout( function(){
				subNav.classList.toggle("is-active");
		  }, 500 );		
	} else {
		hamburger.classList.toggle("is-active");
		subNav.classList.remove("slide-out-blurred-bottom");
		subNav.classList.toggle("slide-in-blurred-bottom");
		subNav.classList.toggle("is-active");
	}
});
function cookieAccept(name) {
    localStorage.setItem(name, 'yesbox');
    removeElement(name + '_info');
}
function removeNewsletter() {
    localStorage.setItem('newsletter', 'yesbox');
    removeElement('mailchimp-top-bar');
}
function removeBarDelayed() {
	setTimeout(function () {
	    localStorage.setItem('newsletter', 'yesbox');
	    removeElement('mailchimp-top-bar');
	}, 5000);		
}
function removeElement(elementId) {
    var element = document.getElementById(elementId);
    if(typeof(element) != 'undefined' && element != null) {
	    element.parentNode.removeChild(element);
    }
}
if (localStorage.getItem('cookies') == 'yesbox') {
    removeElement('cookies_info');
}

var barScrollView = function() {
  var bar = document.getElementById("mailchimp-top-bar");
  if(typeof(bar) != 'undefined' && bar != null) {

	  var close = document.querySelector(".mctb-close");
	  if(typeof(close) != 'undefined' && close != null) {
		  close.innerHTML = '&times;';
		  var y = window.scrollY;
		  if (y >= 100) {	
		    bar.className = "mctb mctb-sticky mctb-position-top mctb-big mctb-icon-inside-bar show"
		  } else {
		    bar.className = "mctb mctb-sticky mctb-position-top mctb-big mctb-icon-inside-bar hide"
		  }
	  }
  }
};

window.addEventListener("scroll", barScrollView);

window.onload = function(){
	var newsletterClose = document.querySelector(".mctb-close");
	if(typeof(newsletterClose) != 'undefined' && newsletterClose != null) {
		newsletterClose.addEventListener('click', removeNewsletter);
	}
	var newsletterCloseSubmit = document.querySelector(".mctb-bar");
	if(typeof(newsletterCloseSubmit) != 'undefined' && newsletterCloseSubmit != null) {
		newsletterCloseSubmit.addEventListener('submit', removeBarDelayed);
	}

	if (localStorage.getItem('newsletter') == 'yesbox') {
	    var element = document.querySelector('.mctb-close');
		if(typeof(element) != 'undefined' && element != null) {
		    element.classList = 'mctb-close hide';
		}
	    removeElement('mailchimp-top-bar');
	}	
}

jQuery(function($) {      
    function setupNewsletter() {
		let isMobile = window.matchMedia("only screen and (max-width: 730px)").matches;
	    if (isMobile) {
	    	if(localStorage.getItem('cookies') != 'yesbox') {
		    	addOverlayStuff();
	    	}
	    } else {
	    	if(localStorage.getItem('cookies') != 'yesbox') {
				$('#mailchimp-top-bar').removeClass('overlay');
				$('#mailchimp-top-bar .w-100').remove();
				$('#mailchimp-top-bar .mctb-open-overlay').remove();

	    		if( $('.mctb-bar .p-u-1-2.lef').length === 0) {
					$('.mctb-bar .mctb-label').wrap('<div class="p-u-1-2 lef"></div>');
					$('.mctb-bar .mctb-email, .mctb-bar .mctb-email-confirm, .sub-checks, .mctb-button').wrapAll('<div class="p-u-1-2 rig text-left"></div>');
					$('.mctb-bar .p-u-1-2').wrapAll('<div class="p-g"></div>');
					$('.mctb-bar .mctb-email, .mctb-bar .mctb-button').wrapAll('<div class="w-100"></div>');

	    		}



		    }
	    }

		$('#mailchimp-top-bar').on('click', '.mctb-close-overlay', function(events){
			$('#mailchimp-top-bar').removeClass('overlay');
			$('#mailchimp-top-bar .w-100').remove();
			$('#mailchimp-top-bar .mctb-close-overlay').remove();
		});    	
    }

    function addOverlayStuff() {
    	if($('.mctb-open-overlay').length === 0) {
	    	var btnText = $('.mctb-button').val();
	    	$('.mctb-bar form').append('<div class="w-100"></div><button type="button" class="p-button p-button-red mctb-open-overlay">' + btnText + '</button>').on('click', function() {
				$('#mailchimp-top-bar').addClass('overlay');
	        	$('.mctb-bar form').append('<span class="mctb-close-overlay">&times;</span>').on('click', function() {
			    	$('.mctb-bar form').remove('.mctb-close-overlay');
				});				
			});    	
	    }
    }

    setupNewsletter();

    $( window ).resize(function() {
    	//setupNewsletter();
    });

 });